import PsychologistsList from "./PsychologistsList/PsychologistsList.vue";
import UserService from "@/services/UserService";
import { toQuery, fromQuery } from "@/utils/filterQuery";

// Função (não constante) pra só ler os services depois dos módulos carregarem
const buildFields = () => [
  {
    key: "approved",
    label: "Aprovação",
    type: "select",
    options: [
      { value: "1", label: "Aprovados" },
      { value: "0", label: "Não aprovados" },
    ],
  },
  {
    key: "online",
    label: "Online",
    type: "select",
    options: [
      { value: "1", label: "Online" },
      { value: "0", label: "Offline" },
    ],
  },
  {
    key: "has_appointment",
    label: "Sessões",
    type: "select",
    options: [{ value: "1", label: "Com sessão concluída" }],
  },
  {
    key: "subscriber_only",
    label: "Assinatura",
    type: "select",
    options: [{ value: "1", label: "Pagantes" }],
  },
  {
    key: "plan_slug",
    label: "Plano",
    type: "select",
    options: [
      { value: UserService.PlanSlugs.plus, label: "Psiapp+" },
      { value: UserService.PlanSlugs.basic, label: "Plano Básico" },
    ],
  },
  { key: "date_from", label: "Cadastro de", type: "date" },
  { key: "date_to", label: "Cadastro até", type: "date" },
  { key: "price_from", label: "Valor de (R$)", type: "number" },
  { key: "price_to", label: "Valor até (R$)", type: "number" },
];

export default {
  name: "Psychologists",
  components: {
    PsychologistsList,
  },
  data() {
    const fields = buildFields();
    return {
      fields,
      // Filtros aplicados (inicializados a partir da URL)
      filters: fromQuery(fields, this.$route.query),
      total: null,
    };
  },
  methods: {
    applyFilters(filters) {
      this.filters = filters;
      this.$router
        .replace({ path: this.$route.path, query: toQuery(this.fields, filters) })
        .catch(() => {});
    },
  },
};
